import { useGetApiV1BannerId } from '@/shared/api/generated';

/**
 * Hook para carregar um Banner para edição.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/banner/{id}`. Desabilitado
 * quando `bannerId` é `undefined` (tela de criação).
 *
 * @param bannerId - ID do banner em edição.
 * @returns `{ banner, isLoading, isError, refetch }`.
 *
 * @example
 * ```tsx
 * const { banner, isLoading } = useBanner(bannerId);
 * ```
 */
export function useBanner(bannerId: number | undefined) {
  const query = useGetApiV1BannerId(bannerId ?? 0, {
    query: { enabled: bannerId !== undefined },
  });

  return {
    banner: query.data,
    isLoading: bannerId !== undefined && query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
